import { SimpleTooltip_NEXT } from '../../../../../../../../shared/frontend/components/presentational/tooltip';
import { ClassIcon } from '../../../../../../../../shared/frontend/scripts/wow/components/ClassIcon';
import { SpecIcon } from '../../../../../../../../shared/frontend/scripts/wow/components/SpecIcon';
import { t } from 'i18next';

function DefaultSpecCombinedSlot(props: any) {
  const { cls, specs, specPriorities } = props;

  const orderedSpecs = specs.sort((a: any, b: any) => {
    const priorityDiff = (specPriorities.get(b.id) || 0) - (specPriorities.get(a.id) || 0);
    if (priorityDiff === 0) {
      return a.id - b.id;
    }
    return priorityDiff;
  });

  return (
    <div className="rec-class-capsule">
      <div className="rec-class-capsule--class-side">
        <div className="rec-class-capsule--class-side-icon-container">
          <SimpleTooltip_NEXT
            tooltip={<span className={`text-bold class-color--${cls.slug}`}>{t(`game:classes.${cls.slug}.name`)}</span>}
          >
            <span
              className={`slds-avatar slds-avatar--small class-bordercolor--${cls.slug}`}
              style={{ borderStyle: 'solid', borderWidth: 1 }}
            >
              <ClassIcon class={cls.slug} />
            </span>
          </SimpleTooltip_NEXT>
        </div>
      </div>
      <div className="rec-class-capsule--specs-side">
        {orderedSpecs.map((spec: any, index: number) => (
          <div key={index} className="rec-class-capsule--spec">
            <SimpleTooltip_NEXT
              tooltip={
                <div>
                  <span className={`text-bold class-color--${cls.slug}`}>
                    {t(`game:specs.${cls.slug}.${spec.slug}.name`)}
                  </span>
                  {specPriorities.get(spec.id) === 2 && (
                    <div className="slds-text-body--small">
                      <i className="fa fa-fw fa-circle-arrow-up text-legendary" />{' '}
                      <i>{t('recruitment:priority.high')}</i>
                    </div>
                  )}
                  {specPriorities.get(spec.id) === 0 && (
                    <div className="slds-text-body--small">
                      <i className="text-muted">{t('recruitment:priority.low')}</i>
                    </div>
                  )}
                </div>
              }
            >
              <span className="slds-avatar slds-avatar--small rio-border--light">
                <SpecIcon class={cls.slug} spec={spec.slug} />
              </span>
              {specPriorities.get(spec.id) === 2 && (
                <i
                  className="fa fa-fw fa-circle-arrow-up rio-text-shadow--heavy text-legendary"
                  style={{ fontSize: 12, position: 'absolute', right: -5, top: -4 }}
                />
              )}
            </SimpleTooltip_NEXT>
          </div>
        ))}
      </div>
    </div>
  );
}

export default DefaultSpecCombinedSlot;
